<!--File: cgp-alert-dialog.template.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/27/2017-->
<!--Desc: CGP Alert Dialog to use instead of js alert.-->
<!--Other Contributors:-->

<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-content>
    <div [innerHTML]="message" class="{{alert ? 'alert alert-' + alert : ''}}"></div>
</div>

<div mat-dialog-actions class="cgp-dialog-actions">
    <span class="cgp-flex-fill"></span>
    <button color="primary" mat-raised-button mat-dialog-close>{{closeLabel}}</button>
</div>